import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { dayNames } from '../utils/constaints';

export default function TutorMatchingStudentDetails({ student }) {
  const weekDays = student?.week_days || [];

  // const availableDays = weekDays.map((d) => dayNames[d.week_day])
  const availableTimes = weekDays.map((d, i) => {
    const from = d.from_time?.slice(0, 5);
    const to = d.to_time?.slice(0, 5);
    if (!from || !to) return null;
    return { id: i, time: `${from} - ${to}`, day: dayNames[d.week_day] };
  });

  return (
    <Grid item xs={12}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 1, md: 3 }}
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Box flex={1}>
          <Typography variant="caption" color="text.secondary" fontWeight={700}>
            STUDENT
          </Typography>
          <Typography variant="body1" fontWeight={600} color="primary.dark">
            {student?.student_name}
          </Typography>
          <Typography variant="caption" sx={{ display: 'block' }}>
            {/* {student?.language_fluency} */}
            {Array.isArray(student.language_fluency)
              ? student.language_fluency.join(', ')
              : typeof student.language_fluency === 'string'
                ? student.language_fluency.split(',').join(', ')
                : '-'}
          </Typography>
        </Box>
        <Box flex={1}>
          <Typography variant="caption" color="text.secondary" fontWeight={700}>
            PREFERENCE
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
            <b>Syllabus:</b> {student?.syllabus_name}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
            <b>Medium:</b> {student?.medium_name}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
            <b>Gender:</b>
            {student?.gender_preference}
          </Typography>
        </Box>
        <Box flex={1}>
          <Typography variant="caption" color="text.secondary" fontWeight={700}>
            AVAILABILITY
          </Typography>
          {availableTimes?.map((e) => (
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography variant="body2" sx={{ color: 'success.main', fontWeight: 500 }}>
                {e?.day}
              </Typography>
              <Typography variant="body2">{e?.time || '-'}</Typography>
            </Stack>
          ))}
        </Box>
        <Box display="flex" alignItems="center">
          <Button
            size="small"
            variant="contained"
            startIcon={<Icon icon="solar:pen-new-square-bold" />}
            onClick={() =>
              window.open(
                `/my-workspace/session-preference?courseenrollmentId=${student?.course_enrollment_id}&studentname=${student?.student_name}&course=${student?.course_name}&phone=${student?.student_mob_no}`,
                '_blank',
              )
            }
          >
            Edit Preference
          </Button>
        </Box>
      </Stack>
    </Grid>
  );
}
